import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromClassroomPresence from './classroom-presence.reducer';
import { ClassroomPresenceUser, OfflineState } from "../models/classroom-presence-user";
import { groupClientsByUserId } from "../util/group-clients";

export const selectClassroomPresenceState = createFeatureSelector<fromClassroomPresence.State>(
  fromClassroomPresence.classroomPresenceFeatureKey
);

const selectClients = createSelector(
    selectClassroomPresenceState,
    (state) => state.clients
);

export const selectClassroomPresence = createSelector(
    selectClients,
    (clients): (ClassroomPresenceUser & OfflineState)[] => clients.map(client => ({
        ...client,
        isOffline: !!client.leftAt,
    }))
);

export const selectClassroomPresenceGroupedByUserId = createSelector(
    selectClassroomPresence,
    groupClientsByUserId
);
